export default {
      id: "color_pie-usage",
      viewBox: "0 0 156 143",
      url: __webpack_public_path__ + "sprite.svg#color_pie",
      toString: function () {
        return this.url;
      }
    }